var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react-hooks/rules-of-hooks */
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useEffect, useRef, useState } from 'react';
import { useLoaderData, useParams, useSearchParams } from 'react-router-dom';
import { getDraft, saveDraft } from 'services/api/engineering-service';
import { LoadingSpinner } from 'components/Shared/Loading/LoadingSpinner/LoadingSpinner';
import { EngineeringDerivedFeature, SaveDraftRequest, } from '@millerknoll/pub-api-schema';
import { useSnackbar } from 'context/snackbar/SnackBarProvider';
import { FeatureModal } from 'components/Shared/FeatureModal/FeatureModal';
import { StyledButton } from 'components/Shared/StyledComponents/StyledButton';
import { useCheckAuthScope } from 'services/helperFunctions/useCheckAuthScope';
import { useLanguageCode } from 'services/helperFunctions/useLanguageCode';
import { UI_WRITE_SCOPES } from 'utils/constants';
import { TableDataRow } from './TableDataRow/TableDataRow';
import styles from './FeaturesAndOptionsTable.module.scss';
export function FeaturesAndOptionsTable(_a) {
    var _this = this;
    var _b, _c;
    var isEditable = _a.isEditable, togglePublish = _a.togglePublish;
    var languageCode = useLanguageCode();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var featureModalRef = useRef(null); // this is used to reach out to functions in AddImpliedFeatureModal Component
    var userHasEditPrivileges = useCheckAuthScope(UI_WRITE_SCOPES);
    var urlParams = useParams();
    var searchParams = useSearchParams()[0];
    var processingDate = (_b = searchParams.get('processingDate')) !== null && _b !== void 0 ? _b : undefined;
    var data = useLoaderData();
    var details = data.details;
    var setSnackbarAlert = useSnackbar().setSnackbarAlert;
    var _d = useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = useState(), featureToInject = _e[0], setFeatureToInject = _e[1];
    var _f = useState(false), addFeatureModal = _f[0], setAddFeatureModal = _f[1];
    var _g = useState(false), showMessageForDuplicateIds = _g[0], setShowMessageForDuplicateIds = _g[1];
    var _h = useState((_c = details === null || details === void 0 ? void 0 : details.features) === null || _c === void 0 ? void 0 : _c.sort(function (a, b) { return a.step - b.step; })), productFeatures = _h[0], setProductFeatures = _h[1];
    var _j = useState(false), isModalLoaded = _j[0], setIsModalLoaded = _j[1];
    var _k = useState(1), featureSeqNumber = _k[0], setFeatureSeqNumber = _k[1];
    var listOfSeqVersion = [];
    var _l = useState(''), searchValue = _l[0], setSearchValue = _l[1];
    var _m = useState(), productFeatureMap = _m[0], setProductFeatureMap = _m[1];
    var newFeatureToInject = {
        featureId: "Implied-".concat(featureSeqNumber),
        type: EngineeringDerivedFeature.type.IMPLIED,
        step: 0,
        optionCode: EngineeringDerivedFeature.type.IMPLIED,
    };
    var handleAddImpliedFeatureClick = function () {
        if (!addFeatureModal) {
            checkPrevSeq();
        }
        setFeatureToInject(newFeatureToInject);
        setAddFeatureModal(function (prevVal) { return !prevVal; });
        setIsModalLoaded(function (prevVal) { return !prevVal; });
        setShowMessageForDuplicateIds(false);
    };
    var checkPrevSeq = function () {
        var _a;
        var impliedFeatureList = (_a = details === null || details === void 0 ? void 0 : details.features) === null || _a === void 0 ? void 0 : _a.filter(function (feature) {
            return feature.featureId.includes('Implied');
        });
        impliedFeatureList === null || impliedFeatureList === void 0 ? void 0 : impliedFeatureList.forEach(function (impliedFeature) {
            var splitListFeature = impliedFeature.featureId.split('-', 2);
            var prevSeqNumber = parseInt(splitListFeature[1], 10);
            listOfSeqVersion.push(prevSeqNumber);
            var newestVersion = Math.max.apply(Math, listOfSeqVersion);
            if (newestVersion > featureSeqNumber) {
                setFeatureSeqNumber(newestVersion + 1);
            }
            else {
                setFeatureSeqNumber(featureSeqNumber + 1);
            }
        });
    };
    var addOneToSequence = function () {
        setFeatureSeqNumber(featureSeqNumber + 1);
        newFeatureToInject.featureId = "Implied-".concat(featureSeqNumber + 1);
    };
    useEffect(function () {
        var obj = {};
        productFeatures === null || productFeatures === void 0 ? void 0 : productFeatures.forEach(function (productFeature) {
            obj[productFeature.featureId] = productFeature;
        });
        setProductFeatureMap(obj);
    }, [productFeatures]);
    useEffect(function () {
        var _a, _b;
        if (isModalLoaded) {
            if (featureToInject === null || featureToInject === void 0 ? void 0 : featureToInject.featureId)
                featureToInject.featureId = "Implied-".concat(featureSeqNumber);
            (_a = featureModalRef.current) === null || _a === void 0 ? void 0 : _a.injectValuesByForce(featureToInject);
            (_b = featureModalRef.current) === null || _b === void 0 ? void 0 : _b.scrollToAddFeatureModal();
        }
    }, [featureToInject, isModalLoaded, featureSeqNumber]);
    var handleSaveButtonClick = function (option, featureInfo) { return __awaiter(_this, void 0, void 0, function () {
        var newDescription, indexOfFeatureId, response, dataAfterNewFeatureSave, newFeatures;
        var _a, _b, _c, _d;
        var _e, _f, _g, _h, _j, _k, _l, _m;
        return __generator(this, function (_o) {
            switch (_o.label) {
                case 0:
                    newDescription = option.desc;
                    indexOfFeatureId = productFeatures === null || productFeatures === void 0 ? void 0 : productFeatures.findIndex(function (featureInArray) { return featureInArray.featureId === featureInfo.newFeatureId; });
                    if (indexOfFeatureId !== -1) {
                        setShowMessageForDuplicateIds(true);
                        return [2 /*return*/];
                    }
                    setIsLoading(function (prevVal) { return !prevVal; });
                    if (!!option.optionCode) return [3 /*break*/, 2];
                    return [4 /*yield*/, saveDraft({
                            productId: (_e = urlParams.productId) !== null && _e !== void 0 ? _e : '',
                            productVersion: (_g = (_f = details === null || details === void 0 ? void 0 : details.metadata) === null || _f === void 0 ? void 0 : _f.productVersion) !== null && _g !== void 0 ? _g : (details === null || details === void 0 ? void 0 : details.header).productVersion,
                            status: SaveDraftRequest.status.DRAFT,
                            feature: {
                                featureId: featureInfo.newFeatureId,
                                type: EngineeringDerivedFeature.type.IMPLIED,
                                step: 0,
                                desc: (_a = {}, _a["".concat(languageCode)] = { desc: featureInfo.newFeatureDescription }, _a),
                                mtrlCd: featureInfo.newMaterialCode,
                                mfgMdlCd: featureInfo.newMFeatureModelCode,
                                prcMdlCd: featureInfo.newPFeatureModelCode,
                            },
                        })];
                case 1:
                    response = _o.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, saveDraft({
                        productId: (_h = urlParams.productId) !== null && _h !== void 0 ? _h : '',
                        productVersion: (_k = (_j = details === null || details === void 0 ? void 0 : details.metadata) === null || _j === void 0 ? void 0 : _j.productVersion) !== null && _k !== void 0 ? _k : (details === null || details === void 0 ? void 0 : details.header).productVersion,
                        status: SaveDraftRequest.status.DRAFT,
                        feature: {
                            featureId: featureInfo.newFeatureId,
                            type: EngineeringDerivedFeature.type.IMPLIED,
                            step: 0,
                            desc: (_b = {}, _b["".concat(languageCode)] = { desc: featureInfo.newFeatureDescription }, _b),
                            mtrlCd: featureInfo.newMaterialCode,
                            mfgMdlCd: featureInfo.newMFeatureModelCode,
                            prcMdlCd: featureInfo.newPFeatureModelCode,
                            options: (_c = {},
                                _c[option.optionCode] = {
                                    optionCode: option.optionCode,
                                    mfgOptMdlCd: option.mfgOptMdlCd,
                                    prcOptMdlCd: option.prcOptMdlCd,
                                    desc: (_d = {}, _d["".concat(languageCode)] = { desc: "".concat(newDescription) }, _d),
                                },
                                _c),
                        },
                    })];
                case 3:
                    response = _o.sent();
                    _o.label = 4;
                case 4:
                    if (response.status !== 200) {
                        setSnackbarAlert({
                            message: response.body.message || '',
                            type: 'error',
                        });
                    }
                    else {
                        setSnackbarAlert({
                            message: "Implied feature with ID '".concat(featureInfo.newFeatureId, "' saved"),
                            type: 'success',
                        });
                    }
                    return [4 /*yield*/, getDraft({ productId: (_l = urlParams.productId) !== null && _l !== void 0 ? _l : '', processingDate: processingDate })];
                case 5:
                    dataAfterNewFeatureSave = _o.sent();
                    newFeatures = (_m = dataAfterNewFeatureSave.details) === null || _m === void 0 ? void 0 : _m.features;
                    setProductFeatures(newFeatures === null || newFeatures === void 0 ? void 0 : newFeatures.sort(function (a, b) { return a.step - b.step; }));
                    setFeatureToInject(newFeatureToInject);
                    setIsLoading(function (prevVal) { return !prevVal; });
                    return [2 /*return*/];
            }
        });
    }); };
    var injectInfoIntoModal = function (val) {
        // triggered by clicking copy in table data row
        checkPrevSeq();
        setAddFeatureModal(true);
        val.featureId = "Implied-".concat(featureSeqNumber);
        setFeatureToInject(val);
        setShowMessageForDuplicateIds(false);
    };
    var handleIsModalLoaded = function () {
        setIsModalLoaded(true);
    };
    var deleteFeatureProgrammatically = function (deleteThisFeatureId) {
        if (deleteThisFeatureId) {
            setProductFeatures(function (prevVal) {
                return prevVal === null || prevVal === void 0 ? void 0 : prevVal.filter(function (feature) { return feature.featureId !== deleteThisFeatureId; });
            });
        }
    };
    var handleFeatureFilterFieldChange = function (filterValue) {
        var _a, _b, _c;
        setSearchValue(filterValue);
        if (filterValue === '') {
            setProductFeatures((_a = details === null || details === void 0 ? void 0 : details.features) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) { return a.step - b.step; }));
        }
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(filterValue)) {
            // value is a string
            setProductFeatures((_b = details === null || details === void 0 ? void 0 : details.features) === null || _b === void 0 ? void 0 : _b.filter(function (feature) { var _a; return (_a = feature.desc) === null || _a === void 0 ? void 0 : _a["".concat(languageCode)].desc.toLowerCase().includes(filterValue.toString().toLowerCase()); }));
            // eslint-disable-next-line no-restricted-globals
        }
        else if (!isNaN(filterValue) && filterValue !== '') {
            // value must be a number
            setProductFeatures((_c = details === null || details === void 0 ? void 0 : details.features) === null || _c === void 0 ? void 0 : _c.filter(function (feature) { return feature.step === +filterValue; }));
        }
    };
    if (isLoading) {
        return (_jsx(Box, __assign({ className: styles.loadingSpinnerContainer }, { children: _jsx(LoadingSpinner, { indicatorSize: 10 }) })));
    }
    return (_jsxs(Box, __assign({ className: styles.container }, { children: [_jsxs(Box, __assign({ className: styles.tableHeaderContainer }, { children: [_jsxs(Box, __assign({ className: styles.titleAndButtonRow }, { children: [_jsx(Typography, __assign({ className: styles.tableLabel }, { children: "Product Features" })), _jsx(Box, __assign({ className: styles.buttonContainer, hidden: !userHasEditPrivileges }, { children: isEditable && (_jsx(StyledButton, { label: !addFeatureModal ? 'Add Implied Feature' : 'Close', handleClick: handleAddImpliedFeatureClick, disabledFromProps: !isEditable, widthFromProps: 160 })) }))] })), _jsx(Box, __assign({ sx: { display: 'flex', flexDirection: 'column', marginRight: '50%' } }, { children: _jsx(TextField, { label: "Filter Features by Step or Description", size: "small", onChange: function (e) { return handleFeatureFilterFieldChange(e.target.value); } }) }))] })), addFeatureModal && (_jsx(FeatureModal, { isEditable: true, saveButtonClick: handleSaveButtonClick, setShowMessageForDuplicateIds: setShowMessageForDuplicateIds, showMessageForDuplicateIds: showMessageForDuplicateIds, featureToInject: featureToInject, addFeatureModal: addFeatureModal, isModalLoaded: handleIsModalLoaded, ref: featureModalRef, addToSequence: addOneToSequence, disableOptionCode: true })), productFeatures && (productFeatures === null || productFeatures === void 0 ? void 0 : productFeatures.length) > 0 ? (_jsx(Box, __assign({ className: styles.table }, { children: _jsxs(Table, { children: [_jsx(TableHead, __assign({ className: styles.tableHead }, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ className: styles.stepNumberHeaderCell }, { children: "Step No." })), _jsx(TableCell, __assign({ className: styles.stepNumberHeaderCell }, { children: "Type" })), _jsx(TableCell, __assign({ className: styles.descriptionHeaderCell }, { children: "Description" }))] }) })), _jsx(TableBody, { children: productFeatures === null || productFeatures === void 0 ? void 0 : productFeatures.map(function (feature, index) { return (_jsx(TableDataRow, { feature: feature, index: index, isEditable: isEditable, productFeaturesMap: productFeatureMap, injectInfoIntoModal: injectInfoIntoModal, handleDelete: deleteFeatureProgrammatically, togglePublish: togglePublish }, feature.featureId)); }) })] }) }))) : (_jsx(Typography, __assign({ sx: { margin: '10px auto', fontSize: '18px' } }, { children: !searchValue || searchValue === ''
                    ? 'No product features'
                    : "No features found when searching for '".concat(searchValue, "'") })))] })));
}
